/* eslint-disable no-restricted-globals */
/* eslint-disable react-hooks/exhaustive-deps */
import { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import {
	Box,
	Modal,
	ModalBody,
	ModalCloseButton,
	ModalContent,
	ModalHeader,
	ModalOverlay,
	Table,
	Thead,
	Tbody,
	Tr,
	Th,
	Td,
	TableContainer,
	useDisclosure,
	Text,
	Flex,
	Badge,
	Button,
	Tooltip,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { gql, useLazyQuery } from '@apollo/client';
import { ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt, faPenSquare } from '@fortawesome/free-solid-svg-icons';
import RichTextEditorViewer from '../../../components/form/RichTextEditorField/viewer';
import ListLoading from '../../../components/ListLoading';
import ReactPaginate from 'react-paginate';
import c from '../../../constant';
import useStore from '../../../store';

const Q_NPS = gql`
	query getUnreadNps($pagerInput: PagerInput!) {
		getUnreadNps(pagerInput: $pagerInput)
	}
`;

const UnreadModal = forwardRef(({ ...props }, ref) => {
	const modal = useDisclosure();
	const { t } = useTranslation();
	const { currentLang: lang } = useStore((state) => state?.currentLang);
	const { push } = useHistory();
	const [page, setPage] = useState(1);
	const [getUnreadNps, { loading, data }] = useLazyQuery(Q_NPS);

	useEffect(open, [data]);

	useEffect(load, [page]);

	useImperativeHandle(ref, () => ({
		openModal() {
			modal?.onOpen();
		},
	}));

	function open() {
		data?.getUnreadNps?.nps?.length > 0 && modal?.onOpen();
	}

	function load() {
		const limit = 5;
		const offset = page ? (page - 1) * limit : 0;
		const pagerInput = { limit, offset };
		const variables = { pagerInput };
		getUnreadNps({ variables });
	}

	function openDetail(item) {
		push(`/note-of-presentation/detail?id=${item?.id}&type=${item?.type}`);
	}

	return (
		<>
			{data?.getUnreadNps?.nps?.length > 0 && (
				<Tooltip
					label={
						lang === 'kh'
							? `អ្នកមានកំណត់បង្ហាញរឿង/របាយការណ៍ ${data?.getUnreadNps?.nps?.length} មិនទាន់បានពិនិត្យ`
							: `You have ${data?.getUnreadNps?.nps?.length} note of presentations/reports to review`
					}
				>
					<Button
						leftIcon={<FontAwesomeIcon icon={faPenSquare} style={{ fontSize: 16 }} />}
						colorScheme="orange"
						variant="solid"
						size="sm"
						borderRadius={c.borderRadius}
						border="1px solid #bdc3c7"
						onMouseDown={modal?.onOpen}
						mr={2}
					>
						{`${t('Important')} (${data?.getUnreadNps?.nps?.length})`}
					</Button>
				</Tooltip>
			)}
			<Modal size="3xl" isOpen={modal?.isOpen} onClose={modal?.onClose}>
				<ModalOverlay />
				<ModalContent borderRadius={c.borderRadius}>
					<ModalHeader pb={0} mb={0}>
						{t('Important')}
					</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Box width="100%">
							<ListLoading
								loading={loading}
								loadedList={data?.getUnreadNps?.nps}
								totalRows={data?.getUnreadNps?.totalRows}
								totalPages={data?.getUnreadNps?.totalPages}
							>
								{({ loadedList, totalPages }) => (
									<Box width="100%" pt={0} pb={8} pl={0} pr={0}>
										<TableContainer mb="2" borderTopWidth={1} borderTopColor="gray.100">
											<Table size="sm" variant="simple">
												<Thead>
													<Tr>
														<Th pl={1} pr={1} pb={3} pt={3}>
															{t('Number')}
														</Th>
														<Th pl={1} pr={1} pb={3} pt={3}>
															{t('Subject')}
														</Th>
														<Th pl={1} pr={1} pb={3} pt={3} isNumeric={true}>
															{t('Step')}
														</Th>
													</Tr>
												</Thead>
												<Tbody>
													{loadedList?.map((item, index) => {
														return (
															<Tr
																_hover={{ bg: 'gray.100' }}
																key={index}
																cursor="pointer"
																bg={item?.notification?.read === false ? 'gray.50' : 'white'}
																onMouseDown={() => openDetail(item)}
															>
																<Td pl={1} pr={1} pb={2} pt={2}>
																	<Text color="#3498DA" fontWeight="bold">
																		{item?.number || 'N/A'}
																		<FontAwesomeIcon
																			icon={faExternalLinkAlt}
																			style={{ fontSize: 12, color: '#3498DA', marginLeft: 4 }}
																		/>
																	</Text>
																</Td>
																<Td pl={1} pr={1} pb={2} pt={2}>
																	<RichTextEditorViewer value={item?.subject} makeup={true} />
																</Td>
																<Td pl={1} pr={1} pb={2} pt={2} isNumeric={true}>
																	<Badge>{t(item?.step)}</Badge>
																</Td>
															</Tr>
														);
													})}
												</Tbody>
											</Table>
										</TableContainer>
										{totalPages > 1 && (
											<Flex justifyContent="flex-end" w="100%" mt={6}>
												<ReactPaginate
													previousLabel={<ChevronLeftIcon fontSize="20px" />}
													nextLabel={<ChevronRightIcon fontSize="20px" />}
													breakLabel={'...'}
													breakClassName={'break-me'}
													disableInitialCallback={true}
													pageCount={totalPages}
													marginPagesDisplayed={2}
													pageRangeDisplayed={3}
													onPageChange={({ selected }) => setPage((selected < 0 ? 0 : selected) + 1)}
													containerClassName={'pagination'}
													activeClassName={'active'}
													initialPage={page - 1 || 0}
												/>
											</Flex>
										)}
									</Box>
								)}
							</ListLoading>
						</Box>
					</ModalBody>
				</ModalContent>
			</Modal>
		</>
	);
});

export default UnreadModal;
